import { phpRequest } from "./phpRequest";

export const newPwdSendAction = (email) => {
  const enteredEmail = email.email;

  return phpRequest.post("/member/forgot-password", {
    email: enteredEmail,
  });
};
